import { httpPublic } from "@/api/httpPublic";

import * as actionTypes from "./actionTypes";

const updateInsuranceList = (data) => {
  return {
    payload: {
      insuranceList: data,
    },
    type: actionTypes.UPDATE_INSURANCE_LIST,
  };
};

// ----------- Thunks --------------

export const fetchInsuranceList = (context) => (dispatch) => {
  return httpPublic
    .post("/v2/patient/insurance", { context })
    .json()
    .then((data) => {
      dispatch(updateInsuranceList(data));

      return data;
    });
};
